import React, { useState } from 'react';
import { SubscriptionManager } from '../SubscriptionManager';
import { trackLeadCaptureEvent, postCalculatorLeadCapture } from '../leadCaptureAnalytics.js';

/** Shown when anonymous Advanced free runs are exhausted — email unlocks one more. */
export function FreeRunsEmailGate({ onEmailCaptured, onUpgradeClick, onDismiss }) {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setIsSubmitting(true);

    const trimmed = email.trim();
    const source = 'free_runs_gate';
    trackLeadCaptureEvent('free_runs_email_capture_attempt', {
      source,
      calculatorTier: 'advanced'
    });

    SubscriptionManager.setAdvancedFreeEmail(trimmed);

    try {
      const { ok, data } = await postCalculatorLeadCapture({
        email: trimmed,
        calculatorType: 'advanced',
        source
      });
      const leadStored = ok && data.leadStored !== false;
      if (leadStored) {
        trackLeadCaptureEvent('free_runs_email_captured', {
          source,
          calculatorTier: 'advanced',
          leadStored: true
        });
      } else {
        trackLeadCaptureEvent('free_runs_email_capture_failed', {
          source,
          calculatorTier: 'advanced',
          leadStored: false,
          error: data.error || data.message || `http_${ok ? 'no_store' : 'error'}`
        });
      }
    } catch (err) {
      trackLeadCaptureEvent('free_runs_email_capture_failed', {
        source,
        calculatorTier: 'advanced',
        leadStored: false,
        error: err?.message || 'network_error'
      });
    }

    setIsSubmitting(false);
    onEmailCaptured(trimmed);
  };

  return (
    <div className="mb-4 rounded-xl border-2 border-amber-200 bg-amber-50 overflow-hidden">
      <div className="bg-amber-500 px-4 py-3 flex items-center justify-between">
        <p className="text-white font-bold text-sm sm:text-base mb-0">You&apos;ve used your free run</p>
        {onDismiss && (
          <button type="button" onClick={onDismiss} className="text-white/80 text-xl leading-none px-1" aria-label="Dismiss">
            ×
          </button>
        )}
      </div>
      <div className="px-4 py-4">
        <p className="text-gray-800 font-medium text-sm mb-1">
          Enter your email to unlock 1 more free run — no payment.
        </p>
        <p className="text-gray-600 text-xs mb-3">
          We&apos;ll also email a Retirement Readiness Checklist. Unsubscribe anytime.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3 mb-3">
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="your.email@example.com"
            required
            disabled={isSubmitting}
            className="w-full px-4 py-3 border-2 border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-amber-400 text-base disabled:bg-gray-100"
            style={{ fontSize: 16 }}
          />
          <button
            type="submit"
            disabled={isSubmitting || !email.trim()}
            className="w-full px-6 py-3 bg-amber-500 active:bg-amber-600 text-white font-bold rounded-lg disabled:opacity-50 text-base"
          >
            {isSubmitting ? 'Unlocking…' : 'Unlock 1 more run'}
          </button>
        </form>
        {onUpgradeClick && (
          <button
            type="button"
            onClick={onUpgradeClick}
            className="w-full text-sm text-amber-800 underline font-semibold"
          >
            Keep testing this plan — from $14.99/mo
          </button>
        )}
      </div>
    </div>
  );
}

export default FreeRunsEmailGate;
